import {
  SET_LINEALCHANNEL_HAS_AN_ERROR,
  SET_LINEALCHANNEL_SUCCESS,
} from 'reducers/linealChannel/constants';

const initialState = {
  data: null,
  error: null,
};

const linealChannel = (state = initialState, action) => {
  switch (action.type) {
    case SET_LINEALCHANNEL_SUCCESS:
      return { ...state, error: null, data: { ...action?.payload } };
    case SET_LINEALCHANNEL_HAS_AN_ERROR:
      return { ...state, error: action?.payload?.error };
    default:
      return state;
  }
};

export default linealChannel;
